import React from "react";
import styled, { keyframes } from "styled-components";
import { StyledOpenShiftCell, StyledWeeklyView } from "./weekly-view.styles";

const pulseAnimation = keyframes`
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
`;

const SkeletonCard = styled.div`
  width: 90%;
  height: 80%;
  border-radius: 5px;
  background: #f0f0f0;
  animation: ${pulseAnimation} 1.5s infinite ease-in-out;
  position: absolute;
  top: 10%;
  left: 5%;
`;

const WeeklyViewSkeleton = ({ daysCount = 7 }) => {
  return (
    <StyledWeeklyView>
      {Array(daysCount)
        .fill()
        .map((_, i) => (
          <StyledOpenShiftCell key={`skeleton-${i}`}>
            <SkeletonCard />
          </StyledOpenShiftCell>
        ))}
    </StyledWeeklyView>
  );
};

export default WeeklyViewSkeleton;
